/**
 * Created by han.xie on 2018/3/19.
 */

// 转换时间long格式到yyyy/mm/dd
let getDayFormatTime = timestamp => {
    let date = new Date(timestamp);
    if (String(timestamp).length === 10) {
        date = new Date(timestamp * 1000);
    }
    let Y = date.getFullYear() + '/';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
    let D = date.getDate();
    return Y+M+D;
};

//转换时间long格式到yyyy-mm-dd HH:MM:SS
let getFormatTime = timestamp =>{
    let date = new Date(timestamp);
    if (String(timestamp).length === 10) {
        date = new Date(timestamp * 1000);
    }
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let D = date.getDate();
    let HH = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let MM = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    let SS = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return Y+M+D+" "+HH+MM+SS;
};

// 1200 | decimal("￥") => ￥ 12.00
let decimal = function(num, symbol){
    let type = typeof num;
    if(symbol === undefined) symbol = "";
    if(type !== "number" && type !== "string") return num;
    return symbol + (Number(num) / 100).toFixed(2);
};

// 隐藏手机号中间四位
let hidePhoneNum = function(phone){
    if (String(phone).length === 11) {
        return String(phone).substr(0,3) + "****" + String(phone).substr(7);
    } else {
        return String(phone);
    }
};

export {
    getDayFormatTime,
    decimal,
    hidePhoneNum,
	  getFormatTime
}



// WEBPACK FOOTER //
// ./src/filters/filters.js